import { getEnv } from '@logic-suite/shared/utils/getEnv';

export const environment = {
  production: true,
  auth: {
    clientId: 'flexClient',
    tenantId: 'Flex',
    get issuer() {
      const env = getEnv('env');
      const s = env === 'production' || env === 'prod' ? '' : `${env}.`;
      return `https://${s}auth.noova.no/realms/`;
    },
    redirectUri: '/callback',
  },
  get errorLevel() {
    return getEnv('env') === 'dev' ? 'warn' : 'none';
  },
  customLogin: true,
  get disabledRoutes(): string[] {
    // const routes = getEnv('env') === 'dev' ? [] : [AppRouteTypes.Profile.toString()];
    // return routes;
    return [];
  },
  showHoodColors: getEnv('env') !== 'prod',
};
